import type { ChainSupportedTokens } from '@chewy/typescript-config/marketplace-types'
import {
  mainnet,
  polygon,
  optimism,
  arbitrum,
  base,
  shibarium
} from 'viem/chains'
import { SHIB_TOKENS } from '../project-specific/tokens'
import { chainSettings, ChainType, defaultNativeAddress } from '../chain-specific/chains'
import { Address } from 'viem'

// Define supported tokens for each chain
// This list needs to match tokens your Marketplace V3 contract is configured to accept
export const SUPPORTED_TOKENS: ChainSupportedTokens[] = [
  {
    chain: {
      id: shibarium.id,
      name: shibarium.name
    },
    tokens: [
      SHIB_TOKENS.chewyswap,
      SHIB_TOKENS.shib,
      SHIB_TOKENS.treat,
      SHIB_TOKENS.leash,
      SHIB_TOKENS.weth,
      SHIB_TOKENS.usdt,
    ]
  },
  {
    chain: {
      id: mainnet.id,
      name: mainnet.name
    },
    tokens: [
      {
        address: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48', // USDC
        symbol: 'USDC',
        name: 'USDC',
        logo: '/images/tokens/usdc.png',
        decimals: 6
      },
      {
        address: '0xdAC17F958D2ee523a2206206994597C13D831ec7', // USDT
        symbol: 'USDT',
        name: 'USDT',
        logo: '/images/tokens/usdt.png',
        decimals: 6
      },
      {
        address: '0x6B175474E89094C44Da98b954EedeAC495271d0F', // DAI
        symbol: 'DAI',
        name: 'DAI',
        logo: '/images/tokens/dai.png',
        decimals: 18
      },
      {
        address: '0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2', // WETH
        symbol: 'WETH',
        name: 'WETH',
        logo: '/images/tokens/weth.png',
        decimals: 18
      }
    ]
  },
]

// Helper function to get supported tokens by chainId
export function getTokensByChainId(
  chainId: number
): ChainSupportedTokens | undefined {
  return SUPPORTED_TOKENS.find(item => item.chain.id === chainId)
}

// Native currency support
export const getNativeCurrency = (chainId: number) => {
  const chainConfig = chainSettings[chainId as ChainType]
  if (!chainConfig) return null

  return {
    address: defaultNativeAddress as Address,
    symbol: chainConfig.nativeCurrency.symbol,
    name: chainConfig.nativeCurrency.name,
    logo: chainConfig.nativeCurrency.logo,
    decimals: chainConfig.nativeCurrency.decimals
  }
}